// update_sql8.ts
// 从版本10升级到11
export const update_sql8 = [
    'DROP TABLE IF EXISTS t_user_ref',
    'create table t_user_ref(uid primary key, isfriend, isstaff, ischain, plat, appkey, main_appkey, lutime, lctime)',
    `update t_version set val=11 where key='db_version'`,
];

// 从版本11升级到12
export const update_sql9 = [
    'DROP TABLE IF EXISTS t_group_summary',
    'create table t_group_summary(tid primary key, uid, name, name_py, name_pys, tag, tagid, member_avatars, ctime, lutime, lctime)',
    `update t_version set val=12 where key='db_version'`,
];

// 从版本12升级到13
export const update_sql10 = ['ALTER TABLE t_group ADD avatar;', `update t_version set val=13 where key='db_version'`];

// 从版本13升级到14
export const update_sql11 = [
    'ALTER TABLE t_group ADD scene;',
    'ALTER TABLE t_group ADD sceneid;',
    `update t_version set val=14 where key='db_version'`,
];